module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PassCode', {
    staticClass: "forceArea",
    attrs: {
      "forcePass": true
    },
    on: {
      "go-frash": _vm.goFrash
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-058b20ec"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/passSet.vue
// module id = 1406
// module chunks = 1